function convertColumnToLine() {
	 var countCols = $('.info-produtos .grade table thead th').length;
     if(countCols == 3 &&  $('.info-produtos .grade table thead .qtd').length > 0) {
    	 //esconde o título da quantidade
	    $('.info-produtos .grade table thead .qtd').hide(); 
	    //altera o strip da tabela para alternar a cada 2 linhas
	    $('.info-produtos .grade table').addClass('dualColor');
	    //clona a coluna da quantidade em uma nova linha
	    $('.info-produtos .grade table tbody tr').each(function(i, el) {
	        var colQtd = $(this).find('td').last();     
	        if (!$(this).next('tr').hasClass('extra')){
	            $(this).after('<tr class="extra"><td>Quantidade:</td><td class="text-right tdQtd'+i+'"></td></tr>');
	            colQtd.find('input').clone().appendTo(".tdQtd"+i);
	        } 
	        //esconde a coluna da quantidade 
	        colQtd.hide();            
	    });
	    initTouchSpin();   
    }   
}

function resetColumn() {
    $('.info-produtos .grade table thead .qtd').show();
    $('.info-produtos .grade table').removeClass('dualColor');        
    $('.info-produtos .grade table tbody tr.extra').remove();
    $('.info-produtos .grade table tbody tr td:last-child').show(); 
}

/* AÇÕES DO QUICKVIEW BOTTOM */
function hoverProduto() {

	$('body').on('click', '.btn-close-quick', function () {
		var $this = $(this);
		var $product = $(this).closest('.product');

		var quickView   = $this.closest(".quick-view");
		quickView.removeClass('active');

		var itemBuy     = $product.find(".bt-buy");
		itemBuy.hide();

		var titProducto = $product.find(".tit");
		titProducto.css('opacity', '1');

		var itemQuick   = $product.find(".bt-quick");
		itemQuick.show();

		var productImage = $product.find('.product-image');
		productImage.css('opacity', '1');

		itemQuick.find('.btn i').removeClass('fa-times').addClass('fa-plus');
	});


	$('.product').on('click', '.bt-quick', function () {
			var itemQuick   = $(this);
			var product     = itemQuick.closest('.product');

			var itemBuy     = product.find(".bt-buy");
			var formBuy     = product.find("form");
			var quickView   = product.find(".quick-view");
			var titProducto = product.find("h1");
			var productImage = product.find('.product-image');

			if (quickView.hasClass('active')) {
				if ($(this).find('.btn i').hasClass('fa-times')) {
					var btnClose = product.find('.btn-close-quick');
					btnClose.trigger('click');
					return;
				}
			} else {
				quickView.addClass('active');
				$(this).find('.btn i').removeClass('fa-plus').addClass('fa-times');
			}

			var quickHeight = $(this).closest('.product').height() - 10;
			quickView.css('height', quickHeight + 'px');

			titProducto.css('opacity', '0');
			productImage.css('opacity', '0.25');

			if ($(itemBuy).attr('class') != undefined) {
				itemQuick.hide();
			}

			itemBuy.show();
			itemBuy.click('.btn',function(e) {
				var nItems = 0;
				$.each(formBuy.find('[name^="quantidade_pv"]'), function(){
					nItems += parseInt($(this).val()) || 0;
				});
				if (nItems == 0) {
					e.preventDefault();
					PNotify.removeAll();
					new PNotify({delay: 2000, animation: 'none', text: 'Você precisa adicionar itens à grade antes de adicioná-los ao carrinho!'});
				}
			});

			formBuy.submit(function(){
				setTimeout(function() {
					formBuy.find('[name^="quantidade_pv"]').val("");
				}, 2000);
			});

		})
		.mouseleave (function() {
			var btnClose = $(this).find('.btn-close-quick');
			btnClose.trigger('click');
		});

}


function closeNoAnimation(image, finalWidth, maxQuickWidth, quickview) {

	var top =  !image.offset() ? 0 : image.offset().top;
	var left =  !image.offset() ? 0 : image.offset().left;

	var parentListItem = image.closest('.product'),
		topSelected = top - $(window).scrollTop(),
		leftSelected = left,
		widthSelected = image.width();

	parentListItem.removeClass('empty-box');
	quickview.velocity("stop").removeClass('opened is-visible add-content animate-width').css({
		"top": topSelected,
		"left": leftSelected,
		"width": widthSelected,
	});

	$('html').removeClass('stop-scrolling');
	$('body').removeClass('overlay-layer');
}

function closeQuickView(finalWidth, maxQuickWidth) {

	var quickview = $('body').find('.cd-quick-view.opened').first();

	quickview.find('.cd-slider-wrapper li').removeClass('selected')
		.first()
		.addClass('selected');

	quickview.find('.touch-spin.quantity').val(0);

	var selectedImage = $('.empty-box').find('img').first();

	closeNoAnimation(selectedImage, finalWidth, maxQuickWidth, quickview);
}



$(function() {
	var $body = $('body');
	var pageName = $body.data('page');

	$('.product').mouseleave(function(){
		$(this).find(".quick-view").removeClass('active');
	});

	/**
	 * QuickView MODAL
	 */
	var $quickViewModal = $('.quick-view-modal');
	if ($quickViewModal.length > 0) {

	    //final width --> this is the quick view image slider width
		//maxQuickWidth --> this is the max-width of the quick-view panel
		var sliderFinalWidth = 800,
			maxQuickWidth = 900,
			hasCarousel = false;

		var $cdQuickView = $('.cd-quick-view');

		// cria um clone no quickview para ser carregado de fora do carousel
		if (pageName == 'home' && $('.product-list.product-list-carousel').length > 0) {

			var $mainQuickView = $('.main-quick-view');
			var appendQuickView = "";

			$cdQuickView.each(function() {
				appendQuickView += '<div class="cd-quick-view">' + $(this).html() + '</div>';
			});

			$mainQuickView
				.append(appendQuickView)
				.css('left', '-1000px')
				.show();

			hasCarousel = true;
		}

		// abre o quickview
		$quickViewModal.on('click', function() {
            openQuickViewModal($(this));
		});

		// carrega o quickview do próximo produto
		$('.cd-next').on('click', function() {
			navigateQuickViewModal($(this), 'next');
		});

		// carrega o quickview do produto anterior
		$('.cd-prev').on('click', function() {
			navigateQuickViewModal($(this), 'prev');
		});

		// fecha o quickview ao clicar fora dele
		$body.on('click', function(event) {
			if (($(event.target).is('.cd-close') || $(event.target).is('body.overlay-layer')) && !$('body').hasClass('block-close')) {
				closeQuickView(sliderFinalWidth, maxQuickWidth);
			}
		});

		// fecha o quickview ao apertar ESC
		$(document).keyup(function(event) {
	    	if (event.which=='27' && !$body.hasClass('block-close')) {
				closeQuickView(sliderFinalWidth, maxQuickWidth);
			}
		});

		// troca a imagem
		$cdQuickView.on('click', '.cd-slider-navigation a', function() {
			updateSlider($(this));
		});

		//center quick-view on window resize
		$(window).on('resize', function() {
			if ($cdQuickView.hasClass('is-visible')) {
				window.requestAnimationFrame(resizeQuickView);
			}
		});
	}

	function navigateQuickViewModal(botao, acao) {
		var	actual 	= botao.closest('.cd-quick-view'),
			open 	= null,
			action 	= null;

		if (hasCarousel) {
			open 	= acao == 'prev' ? actual.prev() : actual.next();
			action 	= actual.closest('.container-product-list').find('.product-list .product .box[data-id="'+open.find('.box').data('id')+'"]').parent().parent().find('.quick-view-modal');
		} else {
			open 	= acao == 'prev' ? actual.closest('.product').prev() : actual.closest('.product').next();
			action 	= open.find('.quick-view-modal');
		}

		$('body').addClass('block-close');

		actual
			.velocity("stop")
			.removeClass('opened is-visible add-content animate-width')
			.closest('.product')
				.removeClass('empty-box');

		openQuickViewModal(action);

		setTimeout(function(){
			$('body').removeClass('block-close');
		}, 800);		
	}

	function openQuickViewModal(botao) {

		var product = botao.closest('.product');
		var selectedImage = product.find('img:eq(0)');
		var	quickview = product.find('.cd-quick-view');

		if (hasCarousel) {
			quickview = botao.closest('.container-product-list').find('.main-quick-view').find('.box[data-id="'+quickview.find('.box').data('id')+'"]').parent();
		}

		if (!botao.hasClass('loaded')) {
			initQuickViewContent(quickview, product);
			botao.addClass('loaded');
			if (quickview.find('.cd-slider-wrapper .cd-slider img').width() < 350) {
				quickview.find('.cd-slider-wrapper').css('width','38%');
				quickview.find('.cd-item-info').css('width','60%');
			}
		}
		$('body').addClass('overlay-layer');
		$('html').addClass('stop-scrolling');

		animateQuickView(selectedImage, sliderFinalWidth, maxQuickWidth, 'open', quickview);

		quickview.addClass('opened');
	}

	//posiciona o quickview hover sobre o produto
    function setQuickViewPositionContent(orig, clone, parent) {

	    var listChanged = false;
	    if ($(window).width() < 768) {
	    	orig.css({
                'width': '100%',
                'height': '540px',
            });
            listChanged = true;
	    } else {
	    	 if (parent.width() < 320){
		        if (orig.width() > 350){
		             orig.css({
		                'width': '350px',
		                'height': '540px',
		            });
		            listChanged = true;
		         }
		    } else {
		        if (orig.width() == 350){
		            orig.css({
		                'width': '430px',
		                'height': '620px',
		            });
		            listChanged = true;
		        }
		    }
	    }
	    if (listChanged){
	        clone.css({
	            'width': orig.css('width'),
	            'height': orig.css('height'),
	        });
	    }

	    var list = parent.closest('.container-product-list').offset();
	    var sobraTop = (orig.height() - parent.height()) / 2;
	    sobraTop = sobraTop > 20 ? sobraTop : 0;
	    var sobraLeft = (orig.width() - parent.width()) / 2;
	    sobraLeft = sobraLeft > 20 ? sobraLeft : 0;
	    var margemTop = parent.offset().top - list.top - sobraTop;
	    var margemLeft = parent.offset().left - list.left - sobraLeft;
	    var cols = $('.product-list .columns-3').length ? 3 : $('.product-list .columns-6').length ? 6 : 4;

	    //ajusta a posição para não cortar na esquerda
	    if (margemLeft < 0 && Math.abs(margemLeft) > parent.offset().left){
	    	margemLeft = 0;
	    }
	    //ajusta a posição para não cortar na direita
	    var maxArea = (parent.closest('.container-product-list').first().width() / cols) * (cols - 1);
	    var area = parent.position().left + sobraLeft;
	    var sobraWindow = ($('main').width() - $('main .container').width()) / 2;
	    if (area > maxArea && sobraWindow < sobraLeft){
	    	clone.css({
		        'top': margemTop+'px',
		        'right': '0',
		        'left':'unset',
		    });
	    } else {
	    	clone.css({
		        'top': margemTop+'px',
		        'left': margemLeft+'px',
		        'right':'unset',
		    });
	    }
        clone.html(orig.clone());

        if (clone.width() > 420){
            clone.find('.grade').css({'height': '338px' });
            clone.find('p.descricao').css({'font-size': '14px' });
        }

	    initQuickViewContent(clone, parent);

	    clone.find('.box').wrap('<form class="form-ajax-adicionar-ao-carrinho" method="post" action="'+clone.find('.box').data('action')+'"></form>');
	    formAjaxAdicionarAoCarrinho($('.form-ajax-adicionar-ao-carrinho'));
	}

	//inicializa os scripts
	function initQuickViewContent(clone, parent) {
		clone.find('.quick.hidden').removeClass('quick, hidden');

		if (clone.find('.box').hasClass('isVariation')) {
			clone.find('.wapper-product-price').hide();
		}

        // if (clone.find(".touch-spin").length) {
        //     clone.find(".touch-spin").each(function() {
        //         var div = $('<div>');
        //         var inputSpinCloned = $(this).clone();
        //         var bsTouchspin = $(this).closest(".bootstrap-touchspin");
        //         $(div.append(inputSpinCloned).html()).insertBefore(bsTouchspin);
        //         bsTouchspin.remove();
        //     });
        // } else  {
	    // 	clone.find("input[type='text']").addClass('touch-spin');
        // }
		//
        // clone.find(".touch-spin").TouchSpin({
        //     min: $(this).attr('min') ? $(this).attr('min') : 0,
        //     max: $(this).attr('max') ? $(this).attr('max') : 9999999,
        //     stepinterval: 50,
        //     maxboostedstep: 10000000,
        //     buttondown_txt: '<i class="fa fa-minus-circle"></i>',
        //     buttonup_txt: '<i class="fa fa-plus-circle"></i>',
        //     buttondown_class: 'btn',
        //     buttonup_class: 'btn'
        // });

        if (hasCarousel) {
            var $myform = $('<form class="form-ajax-adicionar-ao-carrinho" method="post" action="'+clone.find('.box').data('action')+'"></form>');
         	clone.find('.box').parents('.cd-quick-view').wrap($myform);
         	formAjaxAdicionarAoCarrinho($myform);
        }
 
	}

	function updateSlider(navigation) {
		var container = navigation.parents('.cd-slider-wrapper').find('.cd-slider');
		var	activeSlider = container.children('.selected').removeClass('selected');

		if (navigation.hasClass('img-next')) {
			if (!activeSlider.is(':last-child')) {
				activeSlider.next().addClass('selected')
			} else {
				container.children('li').eq(0).addClass('selected')
			}
		} else {
			if (!activeSlider.is(':first-child')) {
				activeSlider.prev().addClass('selected')
			} else {
				container.children('li').last().addClass('selected');
			}
		}
	}

	function updateQuickView(url, quickview) {
		quickview
			.find('.cd-slider li').removeClass('selected')
			.find('img[src="'+ url +'"]')
			.parent('li')
			.addClass('selected');
	}

	function resizeQuickView() {
		var quickview = $('body').find('.cd-quick-view.opened').first();
		var quickViewLeft = ($(window).width() - quickview.width()) / 2;
		var quickViewTop = ($(window).height() - quickview.height()) / 2;
		quickview.css({
		    "top": quickViewTop,
		    "left": quickViewLeft,
		});
	} 

	function animateQuickView(image, finalWidth, maxQuickWidth, animationType, quickview) {
		//store some image data (width, top position, ...)
		//store window data to calculate quick view panel position
		var parentListItem = image.closest('.product'),
			topSelected = image.offset().top - $(window).scrollTop() - 20,
			leftSelected = image.offset().left - 20,
			widthSelected = image.width() * 2,
			heightSelected = image.height(),
			windowWidth = $(window).width(),
			windowHeight = $(window).height(),
			finalLeft = (windowWidth - finalWidth)/2,
			finalHeight = finalWidth * heightSelected/widthSelected,
			finalTop = (windowHeight - finalHeight)/2,
			quickViewWidth = ( windowWidth * .8 < maxQuickWidth ) ? windowWidth * .8 : maxQuickWidth ,
			quickViewLeft = (windowWidth - quickViewWidth)/2;		

			if (finalHeight > 451) {
				finalHeight = 451;
			}

		if( animationType == 'open') {
			//hide the image in the gallery
			parentListItem.addClass('empty-box');
			//place the quick view over the image gallery and give it the dimension of the gallery image
			quickview.css({
			    "top": topSelected,
			    "left": leftSelected,
			    "width": widthSelected,
			}).velocity({
				//animate the quick view: animate its width and center it in the viewport
				//during this animation, only the slider image is visible
			    'top': finalTop+ 'px',
			    'left': finalLeft+'px',
			    'width': finalWidth+'px',
			}, 100, [ 50, 0 ], function(){
				//animate the quick view: animate its width to the final value
				quickview.addClass('animate-width').velocity({
					'left': quickViewLeft+'px',
			    	'width': quickViewWidth+'px',
				}, 0, 'ease' ,function(){
					//show quick view content
					quickview.addClass('add-content');	

					var next = hasCarousel ? quickview.next().find('.box').data('id') : quickview.closest('.product').next().find('.box').data('id');		
					if (next == undefined){
						quickview.find('.cd-next').hide();
					} else {
						quickview.find('.cd-next').show();
					}
					var prev = hasCarousel ? quickview.prev().find('.box').data('id') : quickview.closest('.product').prev().find('.box').data('id');		
					if (prev == undefined){
						quickview.find('.cd-prev').hide();
					} else {
						quickview.find('.cd-prev').show();
					}					
				});
			}).addClass('is-visible');
		} else {
			//close the quick view reverting the animation
			quickview.removeClass('add-content').velocity({
			    'top': finalTop+ 'px',
			    'left': finalLeft+'px',
			    'width': finalWidth+'px',
			}, 0, 'ease', function(){
				$('html').removeClass('stop-scrolling');
				$('body').removeClass('overlay-layer');
				quickview.removeClass('animate-width').velocity({
					"top": topSelected,
				    "left": leftSelected,
				    "width": widthSelected,
				}, 100, 'ease', function(){
					quickview.removeClass('is-visible');
					parentListItem.removeClass('empty-box');
				});
			});
		}
	}
});